<template>
  <div class="dataStatistics">
    <div>
      <div class="top_tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick" >
          <el-tab-pane label="日" name="day"></el-tab-pane>
          <el-tab-pane label="周" name="week"></el-tab-pane>
          <el-tab-pane label="月" name="month"></el-tab-pane>
        </el-tabs>
        <div>
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            size="small"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <span style="margin-left: 30px;">
            <el-button size="small" type="primary" @click="searchByTime">搜 索</el-button>
          </span>
        </div>
      </div>
      <div>
        <el-table :data="tableData" style="width: 100%" size="small " :header-cell-style="rowStyle">
          <el-table-column v-for="(col,col_index) in columns" :prop="col.value" :label="col.label" :key="col_index" :width="col.width"></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="bottom_tip">数据统计时间截止至昨日</div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
export default {
  name: 'dataStatistics',
  data (){
    return {
      activeName:"day",
      tableData:[],
      dateValue: null,
      columns:[
        {value:'timeSection', label:'日期'},
        {value:'taskNumber', label:'参与任务'},
        {value:'callNumber', label:'呼叫人数'},
        {value:'contactSuccessNumber', label:'接通数量'},
        {value:'complete', label:'完成随访人数(率)',width: 140},
        {value:'success', label:'成功数(率)',width: 140},
        {value:'refuse', label:'未成功数(率)'},
        {value:'lose', label:'失访数(率)'},
        {value:'qualified', label:'质控合格数(率)',width: 130},
        {value:'qualityPersonNumber', label:'质控人数'},
        {value:'quotaNumber', label:'指标数量'},
        {value:'quotaFinishRate', label:'指标完成率'}
      ]
    }
  },
  computed: {
    ...mapGetters([
      "username",
      "userid",
    ]),
  },
  watch: {},
  created(){
    let vm = this
    vm.onLoad()
  },
  methods: {
    rowStyle({row, rowIndex}) {
      if (rowIndex == 0) {
        return 'color:#000;background:#F2F3F8;font-size:14px; font-weight:bold;'
      }
    },
    onLoad(){

      this.getTimeSectionStatistics() // 日周月统计数据
    },
    getTimeSectionStatistics(){
      let type = 1  //1：天，2周，3月
      switch (this.activeName) {
        case 'day': type=1; break;
        case 'week': type=2; break;
        case 'month': type=3; break;
      }
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestCallCenterOperationPlatformControllerGetSeatTimeSectionStatistics',
          params: { 
            seatId: this.userid,
            dataType: type
          }
        }
      ).then(res => {
        if (res.status==0) {
          this.tableData = res.retValue.map(item => {
            item.complete=`${item.completeNumber}(${item.completeRate})`
            item.refuse=`${item.refuseNumber}(${item.refuseRate})`
            item.lose=`${item.loseNumber}(${item.loseRate})`
            item.success=`${item.successNumber}(${item.successRate})`
            item.qualified=`${item.qualifiedNumber}(${item.qualifiedRate})`
            item.quotaFinishRate=item.quotaFinishRate?item.quotaFinishRate: '0.0%'
            return item
          })
        }
      })
    },
    searchByTime(){
      console.log('dateValue',this.dateValue);
      if (!this.dateValue) {
        this.$message.error('请选择日期区间！')
        return
      }
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestCallCenterOperationPlatformControllerGetSeatTimeSectionStatisticsByTime',
          params: { 
            seatId: this.userid,
            startTime: this.dateValue[0],
            endTime: this.dateValue[1]
          }
        }
      ).then(res => {
        if (res.status==0) {
          let data = res.retValue
          data.complete=`${data.completeNumber}(${data.completeRate})`
          data.refuse=`${data.refuseNumber}(${data.refuseRate})`
          data.lose=`${data.loseNumber}(${data.loseRate})`
          data.success=`${data.successNumber}(${data.successRate})`
          data.qualified=`${data.qualifiedNumber}(${data.qualifiedRate})`
          data.quotaFinishRate=data.quotaFinishRate?data.quotaFinishRate: '0.0%'
          this.tableData = [data]
        }
      })
    },
    handleClick(tab, event) {
      console.log(tab);
      this.dateValue=null
      this.getTimeSectionStatistics()
    }
  }
}
</script>
<style lang="scss">
.dataStatistics {
  .top_tabs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }
  .bottom_tip {
    font-size: 12px;
    color: #BBB;
    text-align: right;
    margin-top: 20px;
  }
}
</style>